export default __webpack_public_path__ + "static/media/heartbeat.76a2dc5e.svg";